import React from 'react';
import { useFeatures } from '@cordata/buffet';

import Identity from './identity';
import CIT from './cit';
import Navigator from './navigator';

const PatientsFaceSheet = () => {
  const { hasAppIdentity, hasAppCit } = useFeatures();

  if (hasAppIdentity) {
    return <Identity />;
  }

  if (hasAppCit) {
    return <CIT />;
  }

  return <Navigator />;
};

export default PatientsFaceSheet;
